import React, { Fragment } from 'react';
import { lineExampleGroups } from '../../data/howItWorks';
import { ExampleLineRow } from '../../types/howItWorks';
import { Badge } from '../sf/Badge';
import { Td, Th } from '../sf/DataTable';
import { Money } from '../sf/Money';
import { NewBadge } from '../sf/NewBadge';
import { StoredReference } from '../sf/StoredReference';
import { PaidTotalCallout } from './PaidTotalCallout';
function StatusCell({
  row
}: {
  row: ExampleLineRow;
}) {
  if (row.status === 'skipped') return <Badge tone="neutral" data-id="element-297" data-mp="3uqzs2yrf3kuv">Skipped — self-gen</Badge>;
  if (row.status === 'manual') return <Badge tone="info" data-id="element-298" data-mp="3g1v6r8pbt0ij">Manual</Badge>;
  return <Badge tone="neutral" data-id="element-299" data-mp="3g2wh1ayipiz7">Calculated</Badge>;
}
export function LinesVisual() {
  return <div className="space-y-3" data-id="element-300" data-mp="3l1pvb5lmpe0f">
      <PaidTotalCallout data-id="element-301" data-mp="3kyln7x51ly4h" />
      <div className="overflow-x-auto rounded border border-sf-border" data-id="element-302" data-mp="370x4ovyg732l">
        <table className="w-full border-collapse" data-id="element-303" data-mp="37300xxq71sfr">
          <thead data-id="element-304" data-mp="3c09nn5m77pzw">
            <tr data-id="element-305" data-mp="3byou9jbmed3m">
              <Th data-id="element-306" data-mp="3bz6vyvh1xjix">Payee</Th>
              <Th data-id="element-307" data-mp="opcu0qsr3z1f">Component</Th>
              <Th data-id="element-308" data-mp="oolawfgcbts1">Rule Key</Th>
              <Th align="right" data-id="element-309" data-mp="ons3dc9k508u">BPS</Th>
              <Th align="right" data-id="element-310" data-mp="ko1exf7i6w7h">
                Adjusted
                <span className="block text-[11px] font-normal text-sf-weak" data-id="element-311" data-mp="knhvtv64a1rv">pays</span>
              </Th>
              <Th align="right" className="font-normal" data-id="element-312" data-mp="ymra2parilt7">
                Stored (unadjusted)
                <span className="block text-[11px] text-sf-weak" data-id="element-313" data-mp="tp8zkuh3jyj3">reference</span>
              </Th>
              <Th data-id="element-314" data-mp="5z4xwsngy8uq">Status</Th>
            </tr>
          </thead>
          <tbody data-id="element-315" data-mp="10jwwr0e7l58">
            {lineExampleGroups.map(group => <Fragment key={group.id} data-id="element-316" data-mp="foohy1mx48r6">
                <tr data-id="element-317" data-mp="fpq2cwptq7lk">
                  <td colSpan={7} className="border-b border-sf-border bg-[#FAFAF9] px-3 py-1.5" data-id="element-318" data-mp="fpzk5x0pt8g6">
                    <span className="text-[13px] font-semibold" data-id="element-319" data-mp="awn8sol1qy5d">{group.title}</span>
                    <span className="ml-2 text-xs text-sf-weak" data-id="element-320" data-mp="3jcgoj17k05ld">{group.subtitle}</span>
                    {(group.id === 'split' || group.id === 'manual') && <span className="ml-2" data-id="element-321" data-mp="1ibscm3x5kgay">
                        <NewBadge label="NEW" data-id="element-322" data-mp="1ib0nnby29gtn" />
                      </span>}
                  </td>
                </tr>
                {group.rows.map(row => {
              const muted = row.status === 'skipped';
              const signed = row.status === 'manual';
              return <Fragment key={`${group.id}-${row.payee}-${row.component}`} data-id="element-323" data-mp="1w4rnttpwjocp">
                      <tr className={muted ? 'bg-[#F7F7F7] text-[#939393]' : ''} data-id="element-324" data-mp="zer2y5snls0o">
                        <Td className={`whitespace-nowrap py-1.5 pl-6 ${muted ? 'line-through' : 'font-semibold'}`} data-id="element-325" data-mp="14caqxxf5lj5t">{row.payee}</Td>
                        <Td className={`whitespace-nowrap py-1.5 ${muted ? 'line-through' : ''}`} data-id="element-326" data-mp="18fp84retw5ku">{row.component}</Td>
                        <Td className="whitespace-nowrap py-1.5 font-mono text-[11px]" data-id="element-327" data-mp="2jsrnjj56yp3f">{row.ruleKey}</Td>
                        <Td align="right" className="py-1.5" data-id="element-328" data-mp="2or2yxyb4x7nr">
                          {row.bps}
                        </Td>
                        <Td align="right" className="py-1.5 font-semibold" data-id="element-329" data-mp="2yu7yjsdzfojk">
                          {row.adjusted === null ? <span className="font-normal" data-id="element-330" data-mp="2txrbl1iirg82">—</span> : <Money value={row.adjusted} signed={signed} data-id="element-331" data-mp="2tysolbj3icsf" />}
                        </Td>
                        <Td align="right" className="py-1.5" data-id="element-332" data-mp="2p3dcao0qkoy4">
                          {row.pay === null ? <span className="text-sf-weak" data-id="element-333" data-mp="2l21uv5s0na10">—</span> : <StoredReference value={row.pay} signed={signed} compact data-id="element-334" data-mp="2g5kvtgja3b95" />}
                        </Td>
                        <Td className="py-1.5" data-id="element-335" data-mp="2b5p004kqiq4o">
                          <StatusCell row={row} data-id="element-336" data-mp="2b81j4l28b6jb" />
                        </Td>
                      </tr>
                      {row.note && row.status !== 'skipped' && <tr data-id="element-337" data-mp="226lfcw5x62o2">
                          <td colSpan={7} className="border-b border-sf-border px-3 pb-1.5 pl-6 text-xs text-sf-weak" data-id="element-338" data-mp="227mupctyxbbl">
                            {row.note}
                          </td>
                        </tr>}
                    </Fragment>;
            })}
              </Fragment>)}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-sf-weak" data-id="element-339" data-mp="cff21fn9btvp">
        Rows per funded loan: Loan Officer row always created · Team Lead row skipped when Opportunity Owner = Team Leader · Director row skipped when Opportunity Owner =
        Division Leader, and written to the Opportunity’s Division Leader Commissions field. Loan Officer rows use base + bonus BPS; TL / Director rows use their
        employee-record BPS only (Team Lead BPS / Director BPS), no bonus. There is no Division Leader on this Troy loan in the example data.
      </p>
    </div>;
}